module.exports = __webpack_public_path__ + "static/img/footLogo.f94acc57.png";